import React from "react";
import { useTranslation } from "react-i18next";
import ImageGallery from 'react-image-gallery';
import 'react-image-gallery/styles/css/image-gallery.css';

const Gallery = () => {
    const { t } = useTranslation();

    const imageUrls = [
        {
            original: "./img/gallery/1.jpg",
            thumbnail: "./img/gallery/1.jpg",
        }, {
            original: "./img/gallery/2.jpg",
            thumbnail: "./img/gallery/2.jpg",
        }, {
            original: "./img/gallery/3.jpg",
            thumbnail: "./img/gallery/3.jpg",
        }, {
            original: "./img/gallery/4.jpg",
            thumbnail: "./img/gallery/4.jpg",
        }, {
            original: "./img/gallery/5.jpg",
            thumbnail: "./img/gallery/5.jpg",
        }, {
            original: "./img/gallery/6.jpg",
            thumbnail: "./img/gallery/6.jpg",
        }, {
            original: "./img/gallery/7.jpg",
            thumbnail: "./img/gallery/7.jpg",
        }, {
            original: "./img/gallery/8.jpg",
            thumbnail: "./img/gallery/8.jpg",
        }, {
            original: "./img/gallery/9.jpg",
            thumbnail: "./img/gallery/9.jpg",
        }, {
            original: "./img/gallery/10α.jpg",
            thumbnail: "./img/gallery/10α.jpg",
        }, {
            original: "./img/gallery/10β.jpg",
            thumbnail: "./img/gallery/10β.jpg",
        }, {
            original: "./img/gallery/11.jpg",
            thumbnail: "./img/gallery/11.jpg",
        }, {
            original: "./img/gallery/12.jpg",
            thumbnail: "./img/gallery/12.jpg",
        }, {
            original: "./img/gallery/13.jpg",
            thumbnail: "./img/gallery/13.jpg",
        }, {
            original: "./img/gallery/14.jpg",
            thumbnail: "./img/gallery/14.jpg",
        }, {
            original: "./img/gallery/15.jpg",
            thumbnail: "./img/gallery/15.jpg",
        }, {
            original: "./img/gallery/16.jpg",
            thumbnail: "./img/gallery/16.jpg",
        }, {
            original: "./img/gallery/17.jpg",
            thumbnail: "./img/gallery/17.jpg",
        }, {
            original: "./img/gallery/18.jpg",
            thumbnail: "./img/gallery/18.jpg",
        }, {
            original: "./img/gallery/19.jpg",
            thumbnail: "./img/gallery/19.jpg",
        }, {
            original: "./img/gallery/20.jpg",
            thumbnail: "./img/gallery/20.jpg",
        }, {
            original: "./img/gallery/21.jpg",
            thumbnail: "./img/gallery/21.jpg",
        }, {
            original: "./img/gallery/22.jpg",
            thumbnail: "./img/gallery/22.jpg",
        }, {
            original: "./img/gallery/23.jpg",
            thumbnail: "./img/gallery/23.jpg",
        }, {
            original: "./img/gallery/24.jpg",
            thumbnail: "./img/gallery/24.jpg",
        },
         {
            original: "./img/gallery/25.jpg",
            thumbnail: "./img/gallery/25.jpg",
        }, 
         {
            original: "./img/gallery/25a.jpg",
            thumbnail: "./img/gallery/25a.jpg",
        }, 
        {
            original: "./img/gallery/26.jpg",
            thumbnail: "./img/gallery/26.jpg",
        }, {
            original: "./img/gallery/27.jpg",
            thumbnail: "./img/gallery/27.jpg",
        }, {
            original: "./img/gallery/28β. Blurred.png",
            thumbnail: "./img/gallery/28β. Blurred.png",
        }, {
            original: "./img/gallery/29.jpg",
            thumbnail: "./img/gallery/29.jpg",
        }, {
            original: "./img/gallery/30.jpg",
            thumbnail: "./img/gallery/30.jpg",
        }, {
            original: "./img/gallery/31.jpg",
            thumbnail: "./img/gallery/31.jpg",
        }, {
            original: "./img/gallery/32.jpg",
            thumbnail: "./img/gallery/32.jpg",
        }, 

    ];

    return (
        <section className="rooms-section spad">
            <div className="container">
                <ImageGallery stopPropagation items={imageUrls} />
            </div>
        </section>
    );
};

export default Gallery;
